// Turbo normally restores submitters at request end. A snapshot can be taken before that end,
// so retain the original label long enough to make `turbo:before-cache` safe as well.
export class FormBusyRegistry {
  constructor() {
    this.pending = new Map()
  }

  start(form, submission) {
    const submitter = submission?.submitter
    this.pending.set(form, { submitter, original: submission?.originalSubmitText })
  }

  startNative(form, submitter) {
    if (!submitter) return

    const original = submitter.matches("button") ? submitter.innerHTML : submitter.value
    const replacement = submitter.dataset.turboSubmitsWith
    this.pending.set(form, { submitter, original })
    form.setAttribute("aria-busy", "true")
    submitter.disabled = true
    submitter.setAttribute("disabled", "")
    if (!replacement) return

    if (submitter.matches("button")) submitter.innerHTML = replacement
    if (submitter.matches("input")) submitter.value = replacement
  }

  finish(form) {
    this.pending.delete(form)
  }

  reset() {
    for (const [form, { submitter, original }] of this.pending) {
      form.removeAttribute("aria-busy")
      if (!submitter) continue

      submitter.disabled = false
      submitter.removeAttribute("disabled")
      if (!original) continue
      if (submitter.matches("button")) submitter.innerHTML = original
      if (submitter.matches("input")) submitter.value = original
    }
    this.pending.clear()
  }
}
